import fs from 'node:fs';
import { applyPreTurnSnapshot, snapshotFilePath } from '../../git/snapshot/capture.js';
import { getBridgeRoot } from '../../files/cwd/index.js';
import type { MessageHandlerDeps } from '../../routing/message-handler-deps.js';
import type { PersistedPromptTurn } from '../disk-store.js';

export async function runLocalRevertBeforeQueuedPrompt(
  next: PersistedPromptTurn,
  deps: MessageHandlerDeps,
): Promise<boolean> {
  if (next.bridgeServerState !== 'requeued_with_revert') return true;
  const sid = next.sessionId;
  const pl = next.payload as { snapshotRevertTurnId?: string };
  const tid =
    typeof pl.snapshotRevertTurnId === 'string' && pl.snapshotRevertTurnId.trim() !== ''
      ? pl.snapshotRevertTurnId.trim()
      : next.turnId;
  const agentBase = deps.sessionWorktreeManager.getSessionWorktreeRootForSession(sid) ?? getBridgeRoot();
  const file = snapshotFilePath(agentBase, tid);
  try {
    await fs.promises.access(file, fs.constants.F_OK);
  } catch {
    deps.log(
      `[Queue] requeued_with_revert: no pre-turn snapshot for ${tid.slice(0, 8)}…; continuing without revert.`,
    );
    return true;
  }
  const res = await applyPreTurnSnapshot(file, deps.log);
  if (!res.ok) {
    deps.log(`[Queue] requeued_with_revert: snapshot apply failed: ${res.error ?? 'unknown'}`);
  }
  return res.ok;
}
